module.exports = __webpack_public_path__ + "static/media/Repatriation Assistance.02bc6e02.png";